import styled from "@emotion/styled";
import {ReactComponent as editSvgIcon} from "../../../../images/Edit.svg"

export const EditSvgIcon = styled(editSvgIcon)`
    width: 23px;
    height: 23px;
    cursor: pointer;
`;